import React, { Fragment, useEffect, useState } from 'react';

import './mock.css';

const StartMock = ({ history, match }) => {
    const examId = match.params.id;
    const [examType, setExamType] = useState('');
    const examGuardsEnabled = (typeof process !== 'undefined' && process.env.REACT_APP_EXAM_GUARDS || 'true') === 'true';

	useEffect(() => {
        const storedExamType = localStorage.getItem("examType");
        if (storedExamType) {
            setExamType(storedExamType);
        }
    }, []);

    const proceedToExam = (e) => {
        e.preventDefault();

        const h = window.screen.height;
        const w = window.screen.width;
        const t = window.location.href;
        let r;

        if (examType === "theory") {
            r = t.replace('start-mock', 'theories-exam');
        } else {
            r = t.replace('start-mock', 'mock-exam');
        }

        // Open exam window
        window.open(r, 'window', `toolbar=no, menubar=no, resizable=yes,width=${w},height=${h}`);

        // Remove any lingering beforeunload handlers (should only appear inside exam window)
        if (!examGuardsEnabled) {
            // If guards are disabled globally, nothing to do.
        }

        // Avoid redirecting the current tab to dashboard immediately so user isn't prompted about unsaved changes
        // Instead, just leave them on the start page; they can navigate manually.
    };

	return (
		<Fragment>
            <section className="start-mock-sec text-center">
                <div className="container start-mock">
                                        <button
                                            type="button"
                                            className="btn start-mock-btn"
                                            onClick={proceedToExam}
                                            title="Launch the mock exam in a new window"
                                        >
                                                Click to Start &nbsp;<i className="fas fa-arrow-right" />
                                        </button>
                                        <p style={{marginTop:'18px', fontSize:'13px', color:'#666'}}>
                                            The exam opens in a new window. You can return here without losing your session.
                                        </p>
                </div>
            </section>
        </Fragment>
	);
};

export default StartMock;
